import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND
})

const emitir = (boleto) => {
  return instance.post('/', boleto)
}

const list = (params) => {
  return instance.get('/boletos', { params })
}

const getPrintData = (boletoId) => {
  return instance.get(`/${boletoId}`)
}

const email = (params) => {
  let { email, idintegracao} = params
  return instance.post(`/boletos/${idintegracao}/email`, {email})
}

const download = (boletoId) => {
  return instance.get(`/boletos/${boletoId}/imprimir`, { responseType: 'blob' })
}

const getBoleto = (id) => {  
  return instance.get(`/boletos/${id}`)
}

export default {
  download,
  email,
  emitir,
  getBoleto,
  getPrintData,
  list
}
